import { INTEGRATION_URLS } from "../../services/apiConfig.js";
import { INTEGRATION_ERRORS } from "../../common/constants/integrationModule/integrationConstants.js";
import apiClient from "../apiInstance.js";


export const getIntegration = async (softtype) => {
    try {
        const response = await apiClient.post(INTEGRATION_URLS.GET_INTEGRATION_INFO,
            { softtype }
        );
        return response.data;
    } catch (error) {
        console.error(INTEGRATION_ERRORS.FETCH_INTEGRATIONS_ERROR, error);
        throw error;
    }
};

export const getIntegrationOptions = async (softid) => {
    try {
        const response = await apiClient.post(
            INTEGRATION_URLS.GET_INTEGRATION_OPTIONS,
            { softid }
        );
        return response.data;
    } catch (error) {
        console.error(INTEGRATION_ERRORS.FETCH_INTEGRATIONS_ERROR, error);
        throw error;
    }
};

export const updateIntegrationOptions = async ({ id, enRead, enCreate, enEdit, enDelete, softid, softtype }) => {
    try {
        const response = await apiClient.post(
            INTEGRATION_URLS.UPDATE_INTEGRATION_OPTIONS,
            { id, enRead, enCreate, enEdit, enDelete, softid, softtype  }
        );
        return response.data;
    } catch (error) {
        console.error(INTEGRATION_ERRORS.FETCH_INTEGRATIONS_ERROR, error);
        throw error;
    }
};

export const resetIntegration = async ({ softtype }) => {
    try {
        const response = await apiClient.post(
            INTEGRATION_URLS.RESET_INTEGRATION_OPTIONS,
            { softtype }
        );
        return response.data;
    } catch (error) {
        console.error(INTEGRATION_ERRORS.FETCH_INTEGRATIONS_ERROR, error);
        throw error;
    }
};